import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect } from "react"
import { Link, withRouter } from "react-router-dom"
import {
  Card,
  CardBody,
  CardImg,
  Col,
  Container,
  Modal,
  Row,
  Spinner,
} from "reactstrap"
import { FORM_NAMES, LOCAL_STORAGE_TAGS, URL_PATHS } from "constants/index"
import { connect } from "react-redux"
import {
  change,
  Field,
  formValueSelector,
  initialize,
  isDirty,
  reduxForm,
} from "redux-form"
import {
  CheckboxField,
  CustomImageField,
  FileField,
  TextField,
} from "components/RenderInput"
import {
  mapClientFormToApi,
  mapClientSuccessManagerToApi,
  mapApiToClientForm,
  mapUpdatedClientToApi,
} from "./utils"
import validate from "./clientFormValidation"
import {
  addClient,
  getClient,
  getClientSuccessManager,
  postClientSuccessManager,
  resetClientForm,
  updateClient,
  updateClientSuccessManager,
} from "store/actions"

const ClientForm = ({
  logoImage,
  handleSubmit,
  history,
  addClient,
  postClientSuccessManager,
  vendorId,
  loading,
  client,
  clientSuccessManager,
  getClient,
  getClientSuccessManager,
  initializeForm,
  match,
  resetClientForm,
  change,
  updateClientSuccessManager,
  clientSuccessManagerIsDirty,
  updateClient,
}) => {
  useEffect(() => {
    if (match?.params?.id) {
      getClient({ id: match?.params?.id })
      getClientSuccessManager({ vendor_id: match?.params?.id })
    }
    return () => {
      resetClientForm()
    }
  }, [])

  useEffect(() => {
    if (client && clientSuccessManager) {
      initializeForm(mapApiToClientForm(client, clientSuccessManager))
      change("clientID", client?.id)
    }
  }, [client, clientSuccessManager])

  const api_token = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER)
  ).api_token

  const addHandler = data => {
    const hasClientSuccessManager =
      data?.clientSuccessManagerEmail ||
      data?.clientSuccessManagerName ||
      data?.clientSuccessManagerPhone ||
      null
    if (match?.params?.id) {
      updateClient({
        id: match?.params?.id,
        values: mapUpdatedClientToApi({
          ...data,
          vendor_id: vendorId,
          api_token: api_token,
        }),
        history,
      })
      if (
        hasClientSuccessManager &&
        Object.keys(clientSuccessManager).length === 0
      ) {
        postClientSuccessManager(
          mapClientSuccessManagerToApi({
            ...data,
            vendor_id: match?.params?.id,
          })
        )
      } else if (
        Object.keys(clientSuccessManager).length &&
        clientSuccessManagerIsDirty
      ) {
        updateClientSuccessManager({
          id: clientSuccessManager?.id,
          values: {
            ...clientSuccessManager,
            ...mapClientSuccessManagerToApi({
              ...data,
              vendor_id: match?.params?.id,
            }),
          },
        })
      }
    } else {
      addClient({
        client: mapClientFormToApi({
          ...data,
          vendor_id: vendorId,
          api_token: api_token,
        }),
        history,
        callback: hasClientSuccessManager ? postClientSuccessManager : null,
        clientSuccessManager: hasClientSuccessManager
          ? mapClientSuccessManagerToApi(data)
          : null,
      })
    }
  }

  const addAndSendHandler = data => {
    const hasClientSuccessManager =
      data?.clientSuccessManagerEmail ||
      data?.clientSuccessManagerName ||
      data?.clientSuccessManagerPhone ||
      null
    if (match?.params?.id) {
      updateClient({
        id: match?.params?.id,
        values: {
          ...mapUpdatedClientToApi({
            ...data,
            vendor_id: vendorId,
            api_token: api_token,
          }),
          send_invite: true,
        },
        history,
      })
      if (
        hasClientSuccessManager &&
        Object.keys(clientSuccessManager).length === 0
      ) {
        postClientSuccessManager(
          mapClientSuccessManagerToApi({
            ...data,
            vendor_id: match?.params?.id,
          })
        )
      } else if (
        Object.keys(clientSuccessManager).length &&
        clientSuccessManagerIsDirty
      ) {
        updateClientSuccessManager({
          id: clientSuccessManager?.id,
          values: {
            ...clientSuccessManager,
            ...mapClientSuccessManagerToApi({
              ...data,
              vendor_id: match?.params?.id,
            }),
          },
        })
      }
    } else {
      addClient({
        client: {
          ...mapClientFormToApi({
            ...data,
            vendor_id: vendorId,
            api_token: api_token,
          }),
          send_invite: true,
        },
        history,
        callback: hasClientSuccessManager ? postClientSuccessManager : null,
        clientSuccessManager: hasClientSuccessManager
          ? mapClientSuccessManagerToApi(data)
          : null,
      })
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags
          title={match?.params?.id ? "Edit Client" : "Add Client"}
        />
        <Container fluid>
          <Row>
            <Col>
              <BreadcrumbTitle
                title={match?.params?.id ? "Edit Client" : "Add Client"}
                breadcrumbItems={[
                  { title: "Dashboard" },
                  { title: "Client List", link: "/vendors" },
                  { title: match?.params?.id ? "Edit Client" : "Add Client" },
                ]}
              />
            </Col>
          </Row>
          <Row className="d-flex justify-content-end">
            <Col xs="auto" className={"mb-3"}>
              <Link to={URL_PATHS.CLIENTS}>
                <SaveButton
                  type="button"
                  fullWidth={true}
                  color="light"
                  content="Back"
                />
              </Link>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xl={7}>
              <form>
                <Card>
                  <CardBody>
                    <h5>
                      {match?.params?.id ? "Edit Client" : "Add a Client"}
                    </h5>
                    <Row className="my-3 px-3">
                      <Col
                        className="align-self-center"
                        style={{ textAlign: "center" }}
                      >
                        <CardImg
                          src={
                            logoImage?.editedImage
                              ? logoImage?.editedImage
                              : "https://admin.dev.markedprivate.com/app/images/profile_placeholder.jpg"
                          }
                          alt="image"
                          className="rounded avatar-xl"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        className="align-self-center"
                        style={{ textAlign: "center" }}
                      >
                        <Field
                          name="logoImage"
                          component={CustomImageField}
                          onDelete={() => {
                            change("deleteLogo", 1)
                          }}
                        />
                      </Col>
                    </Row>
                    {match?.params?.id && (
                      <Row className="my-3 px-3">
                        <Col>
                          <Field
                            component={TextField}
                            name="clientID"
                            label="Client ID"
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="clientName"
                          label="Client Name"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="clientSiteURL"
                          label="Client Site URL"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="clientContactEmail"
                          label="Client Contact Email"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="contactFirstName"
                          label="Contact First Name"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="contactLastName"
                          label="Contact Last Name"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="phone"
                          label="Phone"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="mobile"
                          label="Mobile"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="address"
                          label="Address"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="clientSuccessManagerEmail"
                          label="Client Success Manager Email"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="clientSuccessManagerName"
                          label="Client Success Manager Name"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="clientSuccessManagerPhone"
                          label="Client Success Manager Phone"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          name="hasOwnApp"
                          label="Has Own App"
                          component={CheckboxField}
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          type="date"
                          name="startDate"
                          label="Start Date"
                        />
                      </Col>
                    </Row>
                    <Row className="mt-4 px-3">
                      <Col>
                        <h5>
                          Information needed for sending iOS notifications
                        </h5>
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="keyID"
                          label="Key ID"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="teamID"
                          label="Team ID"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          component={TextField}
                          name="bundleID"
                          label="Bundle ID"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3 px-3">
                      <Col>
                        <Field
                          name="p8Certificate"
                          component={FileField}
                          onChange={(event, newValue, prevValue) => {
                            console.log("new", newValue)
                            console.log("prev", prevValue)
                            if (prevValue && prevValue?.dataURI) {
                              change("deleteCertificate", 1)
                            }
                            if (!newValue) {
                              change("p8Certificate", null)
                            }
                          }}
                          label="Upload p8 certificate"
                          accept=".p8"
                        />
                      </Col>
                    </Row>
                    <Row className="justify-content-center my-3">
                      <Col xl={3}>
                        <SaveButton
                          type="button"
                          content={match?.params?.id ? "Save" : "Add"}
                          fullWidth={true}
                          onClick={handleSubmit(addHandler)}
                        />
                      </Col>
                      <Col xl={3}>
                        <SaveButton
                          type="button"
                          content={
                            match?.params?.id
                              ? "Save & Send Invite"
                              : "Add & Send Invite"
                          }
                          fullWidth={true}
                          onClick={handleSubmit(addAndSendHandler)}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </form>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal isOpen={loading} centered={true} size="sm">
        <h4 style={{ textAlign: "center" }}>Loading...</h4>
        <CardBody className={"p-2 my-1 text-center"}>
          <Spinner className="ms-2" color="primary" />
        </CardBody>
      </Modal>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.CLIENT)

const mapStateToProps = state => ({
  logoImage: selector(state, "logoImage"),
  vendorId: state.Login.vendorId,
  loading: state.clients.loading,
  client: state.clients.client,
  clientSuccessManager: state.clients.clientSuccessManager,
  clientSuccessManagerIsDirty: isDirty(FORM_NAMES.CLIENT)(
    state,
    ...[
      "clientSuccessManagerEmail",
      "clientSuccessManagerName",
      "clientSuccessManagerPhone",
    ]
  ),
})

const mapDispatchToProps = dispatch => ({
  addClient: values => dispatch(addClient(values)),
  postClientSuccessManager: values =>
    dispatch(postClientSuccessManager(values)),
  getClient: values => dispatch(getClient(values)),
  getClientSuccessManager: values => dispatch(getClientSuccessManager(values)),
  initializeForm: values => dispatch(initialize(FORM_NAMES.CLIENT, values)),
  resetClientForm: () => dispatch(resetClientForm()),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.CLIENT, `${field}`, value)),
  updateClientSuccessManager: values =>
    dispatch(updateClientSuccessManager(values)),
  updateClient: values => dispatch(updateClient(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.CLIENT, validate })(withRouter(ClientForm)))
